<!--
 * @Author: DT
 * @Date: 2023-02-17 15:51:45
 * @LastEditors: DT
 * @LastEditTime: 2023-02-22 10:11:34
 * @Description: file content
 * @FilePath: /yxdcommunity/src/components/yzg/editGroup.vue
-->
<template>
  <!-- 底部弹层 -->
  <van-popup v-model="isShowBottom" position="bottom" round :close-on-click-overlay="false">
    <ul class="pop_list">
      <li @click="handlePopButton('edit')" v-if="currentState == 0 || currentState == 2 || currentState == 1">
        修改接龙拼团信息
      </li>
      <li @click="handlePopButton('end')" v-if="currentState == 0 || currentState == 2 || currentState == 1">
        结束团
      </li>
      <li @click="handlePopButton('copy')" v-if="currentState == 0 || currentState == 2 || currentState == 3 || currentState == 1">复制团</li>
      <li @click="handlePopButton('delete')" v-if="currentState == 3">
        删除团
      </li>
      <li class="cancel" @click="handleClosePop">取消</li>
    </ul>
  </van-popup>
</template>

<script>
import { delChainApi, closeChainApi } from "@/libs/api.js";
export default {
  props: {
    isShowBottom: {
      type: Boolean,
      default: () => false,
    },
    currentId: {
      type: Number,
      default: () => null,
    },
    currentState: {
      type: Number,
      default: () => 0,
      // 2-进行中 3-已结束 0-未开始
    },
    pageType: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    handlePopButton(type) {
      console.log("currentId", this.currentId);
      console.log("pageType", this.pageType);
      this.$emit("toggle", false, "bottom");
      if (type == "edit") {
        if (this.$browser().ios) {
          window.location.href = `objc:ulemobile://action&&UleTogetherBuyCreatVC&hasxib|0#isModification|1#activityId|${this.currentId}#logistics|2`;
        } else {
          // window.location.href = `ulemobile://action&&ui.GroupPublishActivity##activityId::${this.currentId}**isModification::1##logistics::2`;
          window.location.href = `ulemobile://action&&ui.GroupPublishActivity##activityId::${this.currentId}**isModification::1**logistics::2`;
        }
      } else if (type == "copy") {
        if (this.$browser().ios) {
          window.location.href = `objc:ulemobile://action&&UleTogetherBuyCreatVC&hasxib|0#isModification|0#activityId|${this.currentId}#logistics|2`;
        } else {
          // window.location.href = `ulemobile://action&&ui.GroupPublishActivity##activityId::${this.currentId}##logistics::2`;
          window.location.href = `ulemobile://action&&ui.GroupPublishActivity##activityId::${this.currentId}**logistics::2`;
        }
      } else {
        let title = {
          end: "确定结束团",
          delete: "确定删除团",
        }[type];
        this.$dialog
          .confirm({
            title,
            confirmButtonColor: "#FF0303",
            cancelButtonColor: "#999999",
            confirmButtonText: "确定",
          })
          .then(() => {
            console.log(title);
            console.log(type);
            console.log("this.currentId===", this.currentId);
            if (type == "end") {
              console.log("结束团");
              closeChainApi({ id: this.currentId, clientCallType: "H5" }).then((res) => {
                if (res.returnCode == "0000") {
                  if (this.pageType == "list") {
                    // 更新我的发布列表
                    this.$emit("fetch");
                  }
                  // 详情页-跳转有团页
                  else {
                    console.log("跳转有团页");
                    window.location.href = "ulemobile://ulePopView";
                  }
                }
              });
            } else if (type == "delete") {
              console.log("删除团");
              this.$emit("fetch");
              delChainApi({ id: this.currentId, clientCallType: "H5" }).then((res) => {
                if (res.returnCode == "0000") {
                  if (this.pageType == "list") {
                    // 更新我的发布列表
                    this.$emit("fetch");
                  }
                  // 详情页-跳转有团页
                  else {
                    console.log("跳转有团页");
                    window.location.href = "ulemobile://ulePopView";
                  }
                }
              });
            }
            this.$emit("toggle", false, "bottom");
          })
          .catch(() => {
            this.$emit("toggle", true, "bottom");
          });
      }
    },
    handleClosePop() {
      this.$emit("toggle", false, "bottom");
    },
  },
  // watch: {
  //   currentId: function(newVal) {
  //     console.log(newVal);
  //   },
  // },
  created() {},
  mounted() {
    console.log("this.currentState", this.currentState);
  },
};
</script>

<style scoped lang="scss">
.pop_list {
  width: 100%;
  li {
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #323233;
    font-size: 16px;
    &.cancel {
      border-top: 5px solid #f0f0f0;
    }
  }
}
</style>
